import type { StoreActionApi } from 'react-sweet-state';
import type { State } from '../../types';

export const removeCommonFlag =
	(flagId: string | number) =>
	async ({ getState, setState }: StoreActionApi<State>) => {
		const { flags: currentFlags } = getState();
		const flags = currentFlags.filter(({ id }) => id !== flagId);
		setState({
			...getState(),
			flags,
		});
	};
